<template>
    <section class="banner">
        <div class="container">
            <p v-html="bannerText"></p>
        </div>
    </section>
</template>
<script>
export default {
    name: 'globalBanner',
    data: function () {
        return {
            lang: localStorage.lang ? localStorage.lang  : 'en'
        }
    },
    computed: {
        bannerText: function() {
            if(this.lang === 'en') {
                return `The web version of Concussion Ed will be unavailable beginning Friday October 25, 2019.
                        Please ensure you’ve saved any data you may have recorded.
                        Download the new version of the
                        <a href="https://parachute.ca/en/injury-topics/concussion-ed-app/" target="_blank">Concussion Ed App</a>
                        to your mobile device.`
            } else {
                return `La version web de Concussion Ed ne sera plus disponible à partir de vendredi 25 octobre 2019.
                        Assurez-vous de bien sauvegarder les données que vous avez enregistrées.
                        Téléchargez la nouvelle version de l’application
                        <a href="https://parachute.ca/fr/sujets-blessures/concussion-ed-app/" target="_blank">Concussion Ed App</a>
                        sur votre téléphone cellulaire.`
            }
        }
    },
    mounted: function() {
        this.getMenu()
    },
    methods: {
        getMenu: function(){
            this.axios.get(process.env.VUE_APP_URL+'sections', {params:{language:this.lang}})
            .then(response => {
                this.menus = response.data
            })
        },
        mounted: function() {
            this.getMenu()
        },
        checkPath: function(name) {
            return this.$route.path.indexOf(name) !== -1
        },
        setRouterPath: function(menu){
            let path = {}
            if (menu.name == 'checklist') {
                path = {path: '/checklist'}
            } else if(menu.name != 'track') {
                path = menu.customizable === 1 ? {path:'/page/'+menu.name} : {path: '/settings/'+menu.name}
            } else {
                path = {path: '/track/'+menu.name}
            }
            return path
        },
        changeLang: function() {
            localStorage.lang = localStorage.lang == 'en' ? 'fr' : 'en'
            location.reload()
        }
    }
}
</script>

